import { useEffect, useState } from 'react'
import { onItemChanged, readCurrentItem, type MailboxItem } from '../lib/mailbox'

/**
 * The message currently open in the reading pane, kept in sync as the user moves
 * between emails.
 */
export function useMailboxItem(): MailboxItem | null {
    const [item, setItem] = useState<MailboxItem | null>(() => readCurrentItem())

    useEffect(() => {
        const refresh = () => setItem(readCurrentItem())

        // Read once on mount as well: the pane can be opened before Office has
        // settled on the selected item.
        refresh()

        return onItemChanged(refresh)
    }, [])

    return item
}
